import { Form, Select } from "antd";
import { Button as MuiButton } from "@mui/material";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  useState,
} from "react";
import { useTranslation } from "react-i18next";

const layout = {
  labelCol: { span: 100 },
  wrapperCol: { span: 100 },
};

export const ImportExcelModal = ({ sheets, onSubmit }) => {
  const { t } = useTranslation("online-convertor");
  const [fieldsValid, setFieldsValid] = useState({
    mapTransactions: sheets[0],
    mapInstitution: sheets[1],
  });

  const sheetOptions = sheets.map((sheet) => ({ label: sheet, value: sheet }));
  return (
    <Form
      {...layout}
      onValuesChange={(_, values) => setFieldsValid(values)}
      initialValues={fieldsValid}
      name="control-hooks"
      layout="vertical"
    >
      <Form.Item
        name="mapTransactions"
        tooltip={{
          title: t("map-transactions-tooltip"),
          icon: <InfoCircleOutlined />,
        }}
        label={t("map-transactions-label")}
        rules={[{ required: true, message: t("messages-field-is-required") }]}
      >
        <Select
          options={sheetOptions}
          placeholder={t("map-transactions-placeholder")}
        />
      </Form.Item>
      <Form.Item
        name="mapInstitution"
        tooltip={{
          title: t("map-institution-tooltip"),
          icon: <InfoCircleOutlined />,
        }}
        label={t("map-institution-label")}
      >
        <Select
          options={sheetOptions}
          placeholder={t("map-institution-placeholder")}
        />
      </Form.Item>
      <Form.Item>
        <MuiButton
          disabled={!fieldsValid.mapTransactions}
          onClick={() => onSubmit(fieldsValid)}
          variant="contained"
          color="warning"
          size="large"
          sx={{ 
            borderRadius: "8px",
            fontWeight: "600",
            height: "40px",
            padding: "0 20px",
            fontSize: "14px",
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            backgroundColor: fieldsValid.mapTransactions ? "#FF6B35 !important" : "#ccc !important",
            borderColor: fieldsValid.mapTransactions ? "#FF6B35" : "#ccc",
            "&:hover": {
              backgroundColor: fieldsValid.mapTransactions ? "#E55A2B !important" : "#ccc !important",
              borderColor: fieldsValid.mapTransactions ? "#E55A2B" : "#ccc",
            }
          }}
        >
          {t(`import-excel-map-button`)}
        </MuiButton>
      </Form.Item>
    </Form>
  );
};
